import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 group mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-chat-smile-2-fill text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold">黑料天天动漫</span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed mb-4">
              最新、最劲爆的动漫圈黑料资讯平台。每天更新，让你第一时间掌握动漫圈内幕动态。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-base font-heading font-semibold mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-accent-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-heading font-semibold mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">
                  投稿爆料
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">
                  广告合作
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base font-heading font-semibold mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-50/70">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400"></i>
                <span>heimanime@163.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-accent-400"></i>
                <span>010-8888-6666</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-accent-400"></i>
                <span>北京市朝阳区动漫产业园A座</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            &copy; {currentYear} 黑料天天动漫 HeiAnime.com 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <p className="text-xs text-background-50/50">
            本站内容仅供娱乐参考，不构成任何投资建议
          </p>
        </div>
      </div>
    </footer>
  );
}